import '../style.css';

const PendingNonBiometricSession = ()=>{
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='pending-response'>
            <p>Verification Pending</p>
    <div className='description'>
    Thank you for submitting your request.
    <br/><br/>
    To complete the identity verification process,
    please follow the <em><b>Next Steps</b></em> outlined in the email you received from T-Mobile.
    </div>
    
        </div>
            </div>
            </div>
    </div>

    )
    
};

export default PendingNonBiometricSession;